<template>
  <div style="width: 100%;height: 100%">
    <el-row :data="data">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li>公&nbsp;司&nbsp;名&nbsp;称&nbsp;：{{ data[0].GYS_NAME }}</li>
          <li>供&nbsp;&nbsp;&nbsp;&nbsp;应&nbsp;&nbsp;&nbsp;&nbsp;商：{{ data[0].SUPPLIER_NAME }}</li>
          <li>送&nbsp;货&nbsp;日&nbsp;期&nbsp;：{{ data[0].SEND_DAY }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li>制&nbsp;&nbsp;&nbsp;&nbsp;单&nbsp;&nbsp;&nbsp;&nbsp;人：{{ managername }}</li>
          <li>订&nbsp;单&nbsp;编&nbsp;号&nbsp;：{{ data[0].ORDER_CODE }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编号"></el-table-column>
          <el-table-column label="名称" prop="SHORT_NAME" min-width="100"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="单价（元）"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购"></el-table-column>
          <el-table-column label="送货" prop="NEED_COUNT"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收"></el-table-column>
          <el-table-column prop="PAPER_COUNT" label="纸质实收数量" min-width="110">
            <template slot-scope="scope">
              <!-- <el-input :value="currentActualNumber(scope.row)" :placeholder="scope.row.PAPER_COUNT"
                  @focus="getColumnRow(scope.row)" @change="setActualNumber" :disabled="data[0].STATUS>=8" clearable>
                </el-input> -->
              <el-input v-model="scope.row.PAPER_COUNT" :disabled="beChecked"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="RETURN_COUNT" label="退货数量"></el-table-column>
          <el-table-column prop="RETURN_REASON" label="退货理由"></el-table-column>
          <el-table-column prop="REAL_FEE" label="总价（元）"></el-table-column>
          <el-table-column prop="GYSCATALOG_NAME" label="分类"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-button size="medium" @click="subWeekOrder" v-show="!beChecked" style="margin-top: 20px; float: right">核对完毕</el-button>
    </el-row>
  </div>
</template>
<script>
import { supplierDayDetail } from 'api/tcBanlance';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      month: sessionStorage.getItem('month'),
      managername: sessionStorage.getItem('name'),
      tableData: [],
      data: [{
        GYS_NAME: '',
        SUPPLIER_NAME: '',
        SEND_DAY: '',
        ORDER_CODE: '',
      }],
      beChecked: false,
    };
  },
  created() {
    this.queryData();
  },
  methods: {
    queryData() {
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('ORDER_ID')),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
      };
      supplierDayDetail(params).then((result) => {
        this.tableData = result[0].DETAIL.length > 0 ? result[0].DETAIL : [];
        this.data = result[0].TITLE.length > 0 ? result[0].TITLE : [];
        this.beChecked = Boolean(result[0].PAPER_COUNT_STATUS);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 获取某行纸质实收数量
    getColumnRow(row) {
      this.currentCount = row.PAPER_COUNT;
      this.productID = row.ORDER_DETAIL_ID;
    },
    // 设置当前产品的实收数量
    currentActualNumber(row) {
      return row.PAPER_COUNT;
    },
    subWeekOrder() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: sessionStorage.getItem('ORDER_ID'),
            SERVICE_ID: '10026',
            OTYPE: 22,
            PRODUCT_ARRAY: this.tableData.map((item) => ({ ORDER_DETAIL_ID: item.ORDER_DETAIL_ID, PAPER_COUNT: item.PAPER_COUNT, TYPE_UNIT: item.TYPE_UNIT })),
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '核对完成', type: 'success' });
            this.queryData();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
  },
};
</script>
<style scoped>
.ma img {
  width: 105px
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/financeCenter/supplierDayList.vue